export default [
    "24 24",
    '<path d="M20 12H4M4 12L10 18M4 12L10 6" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']
